import dayjs from "dayjs";
import type { IMetaColumn } from "../types/scad";

export default function useFilter() {
  function getColumnFilterControlType(columnMeta: IMetaColumn) {
    const configuredControlType =
      columnMeta.FilterControlType && columnMeta.FilterControlType != ""
        ? columnMeta.FilterControlType
        : columnMeta.ControlType;
    return configuredControlType.split(":")[0];
  }

  function getFilterKey(
    columnMeta: IMetaColumn,
    isAutoQueryFilter: boolean = false,
  ) {
    const controlType = getColumnFilterControlType(columnMeta);

    switch (controlType.toLowerCase()) {
      case "date":
        return columnMeta.DataType.includes("timestamp")
          ? columnMeta.ColumnNamePc + "Between"
          : columnMeta.ColumnNamePc;
      case "select":
      case "checkbox":
      case "number":
      case "textselect":
      case "integer":
      case "percent":
      case "currency":
      case "month":
      case "year":
      case "integer_currency":
        return columnMeta.ColumnNamePc;
      case "datetime":
      case "daterange":
      case "number_range":
      case "integer_range":
      case "percent_range":
      case "currency_range":
        return columnMeta.ColumnNamePc + "Between";
      case "multiselect":
        return columnMeta.ColumnNamePc + (isAutoQueryFilter ? "In" : "[]");
      default:
        return columnMeta.ColumnNamePc + "Contains";
    }
  }

  function getFilterValue(columnMeta: IMetaColumn, value: any) {
    // Return null for empty/falsy values to exclude them from query
    if (
      value === null ||
      value === undefined ||
      value === "" ||
      (Array.isArray(value) && value.length === 0)
    ) {
      return null;
    }

    const controlType = getColumnFilterControlType(columnMeta);

    switch (controlType.toLowerCase()) {
      case "date":
      case "daterange":
        if (value instanceof Array && value.length === 2) {
          const fromDate = dayjs(value[0]);
          const toDate = dayjs(value[1]);
          return `${fromDate
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss")},${toDate
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss")}`;
        }
        const date = dayjs(value);

        if (columnMeta.DataType.includes("timestamp")) {
          return `${date.startOf("day").format("YYYY-MM-DD HH:mm:ss")},${date
            .endOf("day")
            .format("YYYY-MM-DD HH:mm:ss")}`;
        }
        return dayjs(value).format("YYYY-MM-DD");
      case "integer_range":
      case "percent_range":
      case "currency_range":
      case "number_range":
        if (
          value instanceof Array &&
          value.length === 2 &&
          value[0] !== null &&
          value[1] !== null
        ) {
          return `${value[0]},${value[1]}`;
        }
        return null;
      case "multiselect":
        return value.join(",");
      case "datetime":
        // Back end accepts pipe delimited date value for date range
        // Convert the value into start of day and end of day and concat
        const datetime = dayjs(value);
        return `${datetime
          .startOf("day")
          .format("YYYY-MM-DD HH:mm:ss")},${datetime
          .endOf("day")
          .format("YYYY-MM-DD HH:mm:ss")}`;
      default:
        return value;
    }
  }

  return {
    getColumnFilterControlType,
    getFilterKey,
    getFilterValue,
  };
}
